// extracted by mini-css-extract-plugin
export var container = "InternshipCourseReviews-module--container--11d98";
export var controlButtons = "InternshipCourseReviews-module--controlButtons--e12a9";
export var lmsScrollbar = "InternshipCourseReviews-module--lms-scrollbar--937ab";
export var reviewCard = "InternshipCourseReviews-module--reviewCard--a234a";
export var reviewCardBottom = "InternshipCourseReviews-module--reviewCardBottom--61f0f";
export var reviewCardTop = "InternshipCourseReviews-module--reviewCardTop--e20cc";
export var reviewsDesktop = "InternshipCourseReviews-module--reviewsDesktop--d6429";
export var reviewsTablet = "InternshipCourseReviews-module--reviewsTablet--16052";
export var wrapper = "InternshipCourseReviews-module--wrapper--e2269";